module.exports = __webpack_public_path__ + "img/hero.2d822487.webp";